import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useVisibleContainer } from "../hooks/useVisibleContainer";
import { getVanillaEl } from "../domBridge";
import { appState } from "../../state";
import { notifyStateChange } from "../../stateBus";
import { loadGalleryData, exitSelectMode } from "../../galleryApi";

// Route-effect component for "/gallery" (All Media) and "/albums/:albumId"
// (album detail) - they share the exact same gallery grid/header, just
// scoped to a different appState.currentAlbum. Renders nothing itself -
// GalleryScreen.tsx (mounted unconditionally in AppRoot) owns all the
// actual rendering, reading appState reactively; this component's only job
// is translating the URL into the appState fields navigating here implies.
// Title/subtitle/back-button used to be imperatively pushed into static
// DOM nodes here - AlbumHeroHeader.tsx now renders all of that directly
// from appState.albumsDetailId/albums, so this only needs to set state.
export function GalleryRouteScreen() {
  const { albumId } = useParams<{ albumId?: string }>();

  useVisibleContainer("homeView");

  useEffect(() => {
    appState.albumsDetailId = albumId || null;
    appState.currentAlbum = albumId || "all";
    exitSelectMode();
    notifyStateChange();

    getVanillaEl<HTMLElement>("albumComments")?.classList.toggle("d-none", !albumId);

    appState.galleryLoading = true;
    notifyStateChange();
    loadGalleryData().finally(() => {
      appState.galleryLoading = false;
      notifyStateChange();
    });
  }, [albumId]);

  return null;
}
